const jsonHeaders = { 'Content-Type': 'application/json' };

const handleResponse = async (res) => {
  const text = await res.text();
  let data = null;

  // Try to parse JSON, but do NOT crash if it isn't valid JSON
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  // If the HTTP status is not OK, surface a clean error
  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) ||
      text ||                           // raw body as a last resort
      `Request failed (${res.status})`;

    throw new Error(message);
  }

  return data;
};

export async function apiListGoals() {
  const res = await fetch('/api/goals');
  return handleResponse(res);
}

export async function apiAddGoal(payload) {
  const res = await fetch('/api/goals', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function apiUpdateGoal(id, payload) {
  const res = await fetch(`/api/goals/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function apiDeleteGoal(id) {
  const res = await fetch(`/api/goals/${id}`, {
    method: 'DELETE',
  });
  return handleResponse(res);
}